import React from "react";
import FieldGroupDataValidation from "./FieldGroupDataValidation";

function OutboundFieldGroupDataValidation({isVisible}) {
  return (
    <>
      <FieldGroupDataValidation isVisible={isVisible} />
    </>
  );
}

export default OutboundFieldGroupDataValidation